import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import { AFTPullRequest, AFTPullResponse, OCTPushRequest, OCTPushResponse } from 'vopay';

const { api } = vopayApi;

// Debit Card Hooks
export function useDebitCard() {
  const source = axios.CancelToken.source();

  // AFT Pull (Collection)
  const [AFTPullLoading, setAFTPullLoading] = useState(false);

  // OCT Push (Payment)
  const [OCTPushLoading, setOCTPushLoading] = useState(false);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function AFTPull(
    params: Omit<AFTPullRequest, 'Amount'> & {
      Amount: number;
    },
  ): Promise<AFTPullResponse> {
    try {
      setAFTPullLoading(true);
      const res = await api.AFTPull(
        {
          ...params,
          Amount: String(params.Amount),
        },
        source,
      );
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setAFTPullLoading(false);
    }
  }

  async function OCTPush(params: OCTPushRequest): Promise<OCTPushResponse> {
    try {
      setOCTPushLoading(true);
      const res = await api.OCTPush(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setOCTPushLoading(false);
    }
  }

  return {
    // AFT Pull (Collection)
    AFTPullLoading,
    AFTPull: AFTPull,

    // OCT Push (Payment)
    OCTPushLoading,
    OCTPush: OCTPush,
  };
}

export default useDebitCard;
